// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1xinkDY1cKBN08XLyBxki5"};